module.exports = __webpack_public_path__ + "img/newsIndImg1.225af3fc.png";